import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "radio", "otherContainer", "otherInput"]

  connect() {
    this.updateState()
  }

  select(event) {
    const card = event.currentTarget
    const radio = card.querySelector("input[type='radio']")

    if (radio) {
      radio.checked = true
      this.updateState()
    }
  }

  updateState() {
    this.cardTargets.forEach(card => {
      const radio = card.querySelector("input[type='radio']")
      const isChecked = radio.checked

      card.classList.toggle("is-checked", isChecked)

      if (isChecked && radio.value === "Autre") {
        this.showOtherField()
      } else if (isChecked) {
        this.hideOtherField()
      }
    })
  }

  showOtherField() {
    if (!this.hasOtherContainerTarget) return
    this.otherContainerTarget.classList.remove("hidden")
    if (this.hasOtherInputTarget) {
      this.otherInputTarget.required = true
      this.otherInputTarget.focus()
    }
  }

  hideOtherField() {
    if (!this.hasOtherContainerTarget) return
    this.otherContainerTarget.classList.add("hidden")
    if (this.hasOtherInputTarget) {
      this.otherInputTarget.required = false
      this.otherInputTarget.value = ""
    }
  }
}
